import './style.scss';
import { CreateWebsiteSteps } from '../Components/CreateSystemConfigurationSteps/CreateSystemConfigurationSteps';
import {
  TextInput,
  useToastContext,
  useForm,
  TruForm,
  required,
  nameRules,
} from '@trufla-technology/trumarket-react-design-system';
import { CreateWebsiteBody } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types';
import { useHistory } from 'react-router-dom';
import {
  useCreateWebsite,
  useGetWebsiteInfo,
} from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import { IErrorResponse } from 'app/types/ErrorResponse';
import { useEffect } from 'react';

export type props = {
  mode?: string;
  initialData?: CreateWebsiteBody;
};

export const SiteDetails = (props: props) => {
  const history = useHistory<{
    websiteName: string;
  }>();
  const { data } = useGetWebsiteInfo();
  const { state } = history.location;

  const CreateWebsite = useCreateWebsite();
  const form = useForm<CreateWebsiteBody>({
    websiteName: data?.websiteName || history.location.state?.websiteName,
  });
  const toaster = useToastContext();

  const handleFinish = async (formSubmitted: Partial<CreateWebsiteBody>) => {
    try {
      if (!state && !!!data?.environments) {
        await CreateWebsite({
          websiteName: formSubmitted.websiteName as string,
        });
      }
      history.push(`/configurations/system-Configuration/details`);
    } catch (err: unknown) {
      const errorMessage = (
        err as IErrorResponse
      )?.response?.data?.error.replaceAll('body.', '');
      toaster.error(errorMessage || 'Failed to add a site');
    }
  };
  useEffect(() => form.reset(), [form]);

  return (
    <div className="site-details">
      <div className="form">
        <TruForm onFinish={handleFinish} form={form}>
          {<CreateWebsiteSteps step={1} />}
          <div className="details siteName">
            <p className="form-title">Website Details</p>
            <div className="details-input">
              <form.Item
                name="websiteName"
                label="Name"
                rules={[required, ...nameRules]}
              >
                <TextInput disabled={!!data?.environments} />
              </form.Item>
            </div>
          </div>
        </TruForm>
      </div>
    </div>
  );
};
